import styled from 'styled-components'

const MyDiv = styled.div`

.cards{
 border: 1px solid rgba(0, 0, 0, 0.15);
 border-radius: 8px;
 background: #fff;
 padding: 12px 6px 6px 6px;
 filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
}
.view{
  text-decoration: underline;
  color: #006838;
  cursor: pointer;
  }
   .btn {
    background:rgba(0, 104, 56, 1);
    color:white;
    &:hover{
    background:rgba(0, 104, 56, 1);
    color:white;
  }
`
export default MyDiv
